import * as React from 'react';
export const xeroSvg = React.forwardRef(function xeroSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#1AB4D7',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        fillRule: 'nonzero',
        d: 'M15.997 4.034c6.626 0 11.997 5.363 11.997 11.977 0 6.615-5.37 11.977-11.997 11.977C9.371 27.988 4 22.626 4 16.011 4 9.397 9.371 4.034 15.997 4.034zM9.743 16.046l2.047-2.049a.366.366 0 1 0-.522-.514l-2.045 2.041-2.055-2.044a.367.367 0 0 0-.516.52L8.7 16.044 6.653 18.09a.365.365 0 0 0 .256.628c.098 0 .19-.038.259-.107l2.052-2.045 2.043 2.038a.366.366 0 1 0 .526-.51l-2.046-2.048zm10.148 0a2.69 2.69 0 0 0 5.38 0 2.691 2.691 0 0 0-5.38 0zm.76 0a1.931 1.931 0 0 1 3.86 0 1.93 1.93 0 0 1-3.86 0zm1.264 0a.667.667 0 0 0 1.333 0 .667.667 0 0 0-1.333 0zm-2.215-2.64h-.113c-.339 0-.666.107-.939.317a.367.367 0 0 0-.358-.288.362.362 0 0 0-.364.363l.002 4.523a.367.367 0 0 0 .733 0V15.54c0-.927.085-1.302.88-1.4.074-.01.154-.009.154-.009.218-.007.373-.156.373-.358a.368.368 0 0 0-.368-.366zm-2.517 2.116c-.158-.747-.568-1.36-1.192-1.755a2.715 2.715 0 0 0-2.998.08 2.715 2.715 0 0 0-1.053 2.852 2.71 2.71 0 0 0 2.283 2.006c.325.04.64.02.968-.064.281-.068.553-.182.804-.342a2.87 2.87 0 0 0 .688-.651l.013-.014c.146-.181.119-.438-.042-.561-.135-.104-.362-.146-.541.083a2.477 2.477 0 0 1-.129.167 2.105 2.105 0 0 1-.53.427c-.27.143-.576.225-.902.227-1.067-.012-1.638-.755-1.84-1.286a1.925 1.925 0 0 1-.083-.308.691.691 0 0 1-.005-.056h3.83c.524-.012.807-.382.729-.805zm-4.527.07.001-.031a1.943 1.943 0 0 1 3.774.03h-3.775z',
      }),
    ),
  );
});
xeroSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
  width: '32',
  height: '32',
};
export var xero = {
  category: 'brand',
  colorable: false,
  name: 'xero',
  svg: xeroSvg,
};
